// @flow
import sevenElevenIconSrc from './7-eleven-icon.svg';
import benavidesIconSrc from './benavides-icon.svg';
import circleKIconSrc from './circle-k-icon.svg';
import fahorroIconSrc from './fahorro-icon.svg';
import guadalajaraIconSrc from './guadalajara-icon.svg';
import waldoIconSrc from './waldo-icon.svg';
import walmartIconSrc from './walmart-icon.svg';

export function getPaynetBrands(): ImmutableArray<string>{
  return [
    sevenElevenIconSrc,
    benavidesIconSrc,
    circleKIconSrc,
    fahorroIconSrc,
    guadalajaraIconSrc,
    waldoIconSrc,
    walmartIconSrc,
  ];
}
